<template>
  <scroll-bar>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="navActive"
      :collapse="isCollapse"
      unique-opened
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="navItem"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
  import {mapGetters} from 'vuex'
  import SidebarItem from './SidebarItem'
  import ScrollBar from '@/components/ScrollBar'
  import {getMenus} from "@/utils/auth"

  export default {
    data() {
      return {
        navItem: [],
        navActive: ''
      }
    },
    components: {SidebarItem, ScrollBar},
    computed: {
      ...mapGetters([
        'permission_routers',
        'sidebar'
      ]),
      routes() {
        return this.$router.options.routes
      },
      isCollapse() {
        return !this.sidebar.opened
      }
    },
    watch: {
      $route: {
        handler: function (val, oldVal) {
          this.setNavActive();
        },
        // 深度观察监听
        deep: true
      }
    },
    mounted() {
      this.navItem = JSON.parse(getMenus());
      this.setNav(this.navItem);
      this.setNavActive();
    },
    methods: {
      setNav(navItem) {
        var _this = this;
        if (navItem) {
          for (var i = 0; i < navItem.length; i++) {
            if (navItem[i].menuUrl && /detail/i.test(navItem[i].menuUrl)) {
              navItem[i].hidden = true;
            }
            if (navItem[i].childrenMenu && navItem[i].childrenMenu.length > 0) {
              navItem[i].icon = 'table'
            }
            _this.setNav(navItem[i].childrenMenu);
          }
        }

      },
      setNavActive() {
        let p = this.$route.path;
        const sourcePage = this.$route.query.sourcePage;
        const mark = this.$route.query.mark;
        let path = p.split("/")[2];
        // console.log(sourcePage);
        if (path === 'newOrModify') {
          this.navActive = '/user/list';
        } else if (path === 'administrationRole') {
          this.navActive = '/user/list';
        } else if (path === 'roleList') {
          this.navActive = '/user/list';
        } else if (path === 'roleInfo') {
          this.navActive = '/role/list';
        } else if (path === 'jurisdictionDetails') {
          this.navActive = '/privilege/list';
        } else {
          this.navActive = p;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue